export default function ({ store, redirect }) {
  // Redirect to auth if current user is not set
  if (process.client && !store.state.user.currentUser && store.state.cart.type !== 'shop') {
    return redirect('/ordering/customer')
  }
}
